module.exports = __webpack_public_path__ + "static/media/loading-step.6acfb3eb.png";